import { GenericObject, copyFields } from '@synergy/models';

import { ProductSnapshot } from '../../../common/models/product-snapshot';
import { TaxRate } from '../../../common/models/tax-rate';

export class InvoiceProductItem extends ProductSnapshot {
    public id!: number;
    public position!: number;
    public taxRate!: TaxRate;

    public static fromPlainObject(object: GenericObject): InvoiceProductItem {
        const invoiceItem = new InvoiceProductItem();

        // Import own keys
        copyFields(object, invoiceItem);

        // Import from base class (snapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite intersecting keys with base keys
        copyFields(productSnapshot, invoiceItem);

        return invoiceItem;
    }
}
